export default __webpack_public_path__ + "media/images/new_year/destination_2-ff0642ed1c189d0e657c03798385cfed.jpg";